/* prettier-ignore-start */
/* tslint:disable */
/* eslint-disable */
/* 该文件由 yapi-to-typescript 自动生成，请勿直接修改！！！ */
// @ts-ignore
// prettier-ignore
import { QueryStringArrayFormat, Method, RequestBodyType, ResponseBodyType, prepare } from 'yapi-to-typescript';
// @ts-ignore
import request from "../request";
const mockUrl_0_0_0_0 = "http://127.0.0.1:50505/mock/0";
const devUrl_0_0_0_0 = "";
const prodUrl_0_0_0_0 = "";
const dataKey_0_0_0_0 = "data";
/**
 * 接口 商品欠货列表 的 **请求配置**
 *
 * @分类 采购工作台(不含触达，开单)
 * @请求头 `POST /erp/Deduction/goodsOweList`
 */
const postGoodsOweListRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: "/erp/Deduction/goodsOweList",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postGoodsOweList",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 商品欠货列表 的 **请求函数**
 *
 * @分类 采购工作台(不含触达，开单)
 * @请求头 `POST /erp/Deduction/goodsOweList`
 */
export const postGoodsOweList = /*#__PURE__*/ (requestData, ...args) => {
  return request(prepare(postGoodsOweListRequestConfig, requestData), ...args);
};
postGoodsOweList.requestConfig = postGoodsOweListRequestConfig;
const mockUrl_0_0_0_1 = "http://127.0.0.1:50505/mock/0";
const devUrl_0_0_0_1 = "";
const prodUrl_0_0_0_1 = "";
const dataKey_0_0_0_1 = "data";
/**
 * 接口 退换货恢复欠货 的 **请求配置**
 *
 * @分类 4.53.0
 * @请求头 `POST /erp/Deduction/exchangeReturnGoodsArrears`
 */
const postExchangeReturnGoodsArrearsRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_1,
  devUrl: devUrl_0_0_0_1,
  prodUrl: prodUrl_0_0_0_1,
  path: "/erp/Deduction/exchangeReturnGoodsArrears",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_1,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postExchangeReturnGoodsArrears",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 退换货恢复欠货 的 **请求函数**
 *
 * @分类 4.53.0
 * @请求头 `POST /erp/Deduction/exchangeReturnGoodsArrears`
 */
export const postExchangeReturnGoodsArrears = /*#__PURE__*/ (
  requestData,
  ...args
) => {
  return request(
    prepare(postExchangeReturnGoodsArrearsRequestConfig, requestData),
    ...args
  );
};
postExchangeReturnGoodsArrears.requestConfig =
  postExchangeReturnGoodsArrearsRequestConfig;
const mockUrl_0_0_0_2 = "http://127.0.0.1:50505/mock/0";
const devUrl_0_0_0_2 = "";
const prodUrl_0_0_0_2 = "";
const dataKey_0_0_0_2 = "data";
/**
 * 接口 抵扣列表 的 **请求配置**
 *
 * @分类 #4478
 * @请求头 `POST /erp/Deduction/goodsDedList`
 */
const postGoodsDedListRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_2,
  devUrl: devUrl_0_0_0_2,
  prodUrl: prodUrl_0_0_0_2,
  path: "/erp/Deduction/goodsDedList",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_2,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postGoodsDedList",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 抵扣列表 的 **请求函数**
 *
 * @分类 #4478
 * @请求头 `POST /erp/Deduction/goodsDedList`
 */
export const postGoodsDedList = /*#__PURE__*/ (requestData, ...args) => {
  return request(prepare(postGoodsDedListRequestConfig, requestData), ...args);
};
postGoodsDedList.requestConfig = postGoodsDedListRequestConfig;
/**
 * 接口 抵扣转欠货 的 **请求配置**
 *
 * @分类 #4478
 * @请求头 `POST /erp/Deduction/dedTransferOut`
 */
const postDedTransferOutRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_2,
  devUrl: devUrl_0_0_0_2,
  prodUrl: prodUrl_0_0_0_2,
  path: "/erp/Deduction/dedTransferOut",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_2,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postDedTransferOut",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 抵扣转欠货 的 **请求函数**
 *
 * @分类 #4478
 * @请求头 `POST /erp/Deduction/dedTransferOut`
 */
export const postDedTransferOut = /*#__PURE__*/ (requestData, ...args) => {
  return request(
    prepare(postDedTransferOutRequestConfig, requestData),
    ...args
  );
};
postDedTransferOut.requestConfig = postDedTransferOutRequestConfig;
const mockUrl_0_0_0_3 = "http://127.0.0.1:50505/mock/0";
const devUrl_0_0_0_3 = "";
const prodUrl_0_0_0_3 = "";
const dataKey_0_0_0_3 = "data";
/**
 * 接口 在途转欠货申请 的 **请求配置**
 *
 * @分类 5412
 * @请求头 `POST /erp/Deduction/addTurnOweApply`
 */
const postAddTurnOweApplyRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_3,
  devUrl: devUrl_0_0_0_3,
  prodUrl: prodUrl_0_0_0_3,
  path: "/erp/Deduction/addTurnOweApply",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_3,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postAddTurnOweApply",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 在途转欠货申请 的 **请求函数**
 *
 * @分类 5412
 * @请求头 `POST /erp/Deduction/addTurnOweApply`
 */
export const postAddTurnOweApply = /*#__PURE__*/ (requestData, ...args) => {
  return request(
    prepare(postAddTurnOweApplyRequestConfig, requestData),
    ...args
  );
};
postAddTurnOweApply.requestConfig = postAddTurnOweApplyRequestConfig;
/* prettier-ignore-end */



// WEBPACK FOOTER //
// ./src/openapi/erp/deduction.js